var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _objectWithoutProperties = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('os'),
    EOL = _require.EOL;

var base64url = require('../help/base64url');

var isDisjoint = require('../help/is_disjoint');

var isObject = require('../help/is_object');

var validateCrit = require('../help/validate_crit');

var getKey = require('../help/get_key');

var _require2 = require('../jwks'),
    KeyStore = _require2.KeyStore;

var errors = require('../errors');

var _require3 = require('../jwa'),
    check = _require3.check,
    verify = _require3.verify;

var JWK = require('../jwk');

var _require4 = require('./serializers'),
    resolveSerialization = _require4.detect;

validateCrit = validateCrit.bind(undefined, errors.JWSInvalid);
var SINGLE_RECIPIENT = new Set(['compact', 'flattened', 'preparsed']);
/*
 * @public
 */

var jwsVerify = function jwsVerify(skipDisjointCheck, serialization, jws, key) {
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref$crit = _ref.crit,
      crit = _ref$crit === void 0 ? [] : _ref$crit,
      _ref$complete = _ref.complete,
      complete = _ref$complete === void 0 ? false : _ref$complete,
      algorithms = _ref.algorithms;

  key = getKey(key, true);

  if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some(function (s) {
    return typeof s !== 'string' || !s;
  }))) {
    throw new TypeError('"algorithms" option must be an array of non-empty strings');
  } else if (algorithms) {
    algorithms = new Set(algorithms);
  }

  if (!Array.isArray(crit) || crit.some(function (s) {
    return typeof s !== 'string' || !s;
  })) {
    throw new TypeError('"crit" option must be an array of non-empty strings');
  }

  if (!serialization) {
    serialization = resolveSerialization(jws);
  }

  var prot; // protected header

  var header; // unprotected header

  var payload;
  var signature;
  var alg; // treat general format with one recipient as flattened
  // skips iteration and avoids multi errors in this case

  if (serialization === 'general' && jws.signatures.length === 1) {
    serialization = 'flattened';

    var _jws = jws,
        _signatures = _jws.signatures,
        _root = _objectWithoutProperties(_jws, ["signatures"]);

    jws = _objectSpread({}, _root, {}, _signatures[0]);
  }

  var decoded;

  if (SINGLE_RECIPIENT.has(serialization)) {
    var parsedProt = {};

    switch (serialization) {
      case 'compact':
        // compact serialization format
        var _jws$split = jws.split('.');

        var _jws$split2 = _slicedToArray(_jws$split, 3);

        prot = _jws$split2[0];
        payload = _jws$split2[1];
        signature = _jws$split2[2];
        break;

      case 'flattened':
        // flattened serialization format
        var _jws2 = jws;
        prot = _jws2.protected;
        payload = _jws2.payload;
        signature = _jws2.signature;
        header = _jws2.header;
        break;

      case 'preparsed':
        {
          // from the JWT module
          var _jws3 = jws;
          decoded = _jws3.decoded;

          var _jws$token$split = jws.token.split('.');

          var _jws$token$split2 = _slicedToArray(_jws$token$split, 3);

          prot = _jws$token$split2[0];
          payload = _jws$token$split2[1];
          signature = _jws$token$split2[2];
          break;
        }
    }

    if (!header) {
      skipDisjointCheck = true;
    }

    if (decoded) {
      parsedProt = decoded.header;
    } else if (prot) {
      try {
        parsedProt = base64url.JSON.decode(prot);
      } catch (err) {
        throw new errors.JWSInvalid('could not parse JWS protected header');
      }
    } else {
      skipDisjointCheck = skipDisjointCheck || true;
    }

    if (!skipDisjointCheck && !isDisjoint(parsedProt, header)) {
      throw new errors.JWSInvalid('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');
    }

    var combinedHeader = _objectSpread({}, parsedProt, {}, header);

    validateCrit(parsedProt, header, crit);
    alg = parsedProt.alg || header && header.alg;

    if (!alg) {
      throw new errors.JWSInvalid('missing JWS signature algorithm');
    } else if (algorithms && !algorithms.has(alg)) {
      throw new errors.JOSEAlgNotWhitelisted('alg not whitelisted');
    }

    if (key instanceof KeyStore) {
      var keystore = key;
      var keys = keystore.all({
        kid: combinedHeader.kid,
        alg: combinedHeader.alg,
        key_ops: ['verify']
      });

      switch (keys.length) {
        case 0:
          throw new errors.JWKSNoMatchingKey();

        case 1:
          // treat the call as if a Key instance was passed in
          // skips iteration and avoids multi errors in this case
          key = keys[0];
          break;

        default:
          {
            var _errs = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _key = _step.value;

                try {
                  return jwsVerify(true, serialization, jws, _key, {
                    crit: crit,
                    complete: complete,
                    algorithms: algorithms ? _toConsumableArray(algorithms) : undefined
                  });
                } catch (err) {
                  _errs.push(err);

                  continue;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var _multi = new errors.JOSEMultiError(_errs);

            if (_toConsumableArray(_multi).some(function (e) {
              return e instanceof errors.JWSVerificationFailed;
            })) {
              throw new errors.JWSVerificationFailed();
            }

            throw _multi;
          }
      }
    }

    if (key === JWK.EmbeddedJWK) {
      if (!isObject(combinedHeader.jwk)) {
        throw new errors.JWSInvalid('JWS Header Parameter "jwk" must be a JSON object');
      }

      key = JWK.asKey(combinedHeader.jwk);

      if (key.type !== 'public') {
        throw new errors.JWSInvalid('JWS Header Parameter "jwk" must be a public key');
      }
    } else if (key === JWK.EmbeddedX5C) {
      if (!Array.isArray(combinedHeader.x5c) || !combinedHeader.x5c.length || combinedHeader.x5c.some(function (c) {
        return typeof c !== 'string' || !c;
      })) {
        throw new errors.JWSInvalid('JWS Header Parameter "x5c" must be a JSON array of certificate value strings');
      }

      key = JWK.asKey("-----BEGIN CERTIFICATE-----".concat(EOL).concat((combinedHeader.x5c[0].match(/.{1,64}/g) || []).join(EOL)).concat(EOL, "-----END CERTIFICATE-----"), {
        x5c: combinedHeader.x5c
      });
    }

    check(key, 'verify', alg);
    var toBeVerified = Buffer.concat([Buffer.from(prot || ''), Buffer.from('.'), Buffer.isBuffer(payload) ? payload : Buffer.from(payload)]);

    if (!verify(alg, key, toBeVerified, base64url.decodeToBuffer(signature))) {
      throw new errors.JWSVerificationFailed();
    }

    if (combinedHeader.b64 === false) {
      payload = Buffer.from(payload);
    } else {
      payload = base64url.decodeToBuffer(payload);
    }

    if (complete) {
      var result = {
        payload: payload,
        key: key
      };
      if (prot) result.protected = parsedProt;
      if (header) result.header = header;
      return result;
    }

    return payload;
  } // general serialization format


  var _jws4 = jws,
      signatures = _jws4.signatures,
      root = _objectWithoutProperties(_jws4, ["signatures"]);

  var errs = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = signatures[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var recipient = _step2.value;

      try {
        return jwsVerify(false, 'flattened', _objectSpread({}, root, {}, recipient), key, {
          crit: crit,
          complete: complete,
          algorithms: algorithms ? _toConsumableArray(algorithms) : undefined
        });
      } catch (err) {
        errs.push(err);
        continue;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var multi = new errors.JOSEMultiError(errs);

  if (_toConsumableArray(multi).some(function (e) {
    return e instanceof errors.JWSVerificationFailed;
  })) {
    throw new errors.JWSVerificationFailed();
  } else if (_toConsumableArray(multi).every(function (e) {
    return e instanceof errors.JWKSNoMatchingKey;
  })) {
    throw new errors.JWKSNoMatchingKey();
  }

  throw multi;
};

module.exports = {
  bare: jwsVerify,
  verify: jwsVerify.bind(undefined, false, undefined)
};